// extracted by mini-css-extract-plugin
export default {"container":"cjtx22jkj","tableWrap":"ctzend0h4","characteristicsTable":"ch9mn9jpu","planHolder":"cwxcq7jx1","icon":"csk35mmf8","title":"crnefmyf7","priceCol":"ckye9iiaq"};